

import type { VitrineAppProps, VitrineTipo2Props, VitrineTipo3Props } from './types/vitrineApp.props'
import { RenderVitrineTipo2 } from './RenderVitrineTipo2/RenderVitrineTipo2'
import { tipoVitrine } from './data/tipoVitrine'
import { RenderVitrineTipo3 } from './RenderVitrineTipo3/RenderVitrineTipo3'

export default class VitrineApp {
    constructor(props: VitrineAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return

        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)

        const tipo = Number(props.tipoVitrine)

        switch (tipo) {
            case tipoVitrine.PRODUTOS_BLACK_FRIDAY: {
                const {...restProps } = props as VitrineTipo2Props
                root.render(<RenderVitrineTipo2 {...restProps} />)
                break
            }

            case tipoVitrine.VITRINE_LANDING_PAGE: {
                const {...restProps } = props as VitrineTipo3Props
                root.render(<RenderVitrineTipo3 {...restProps} />)
                break
            }

            default:
                console.warn(`Tipo de vitrine não tratado: ${tipo}`)
        }
    }
}
